import { useContext } from 'react';
import { FormContext } from '../components';

export function useFormContext() {
    return useContext(FormContext);
}
